import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PlusCircle } from '../../icons';
import { useIsInBottomSheet } from '../BottomSheet';
import { useOverlayContext } from '../OverlayContext';
import { TextButton } from '../TextButton';
import { Typography } from '../Typography';
import styles from './EnhancedAutocomplete.module.scss';
import { EnhancedAutocompleteTestIds, mapDataToOption } from './EnhancedAutocomplete.utils';
export const NewItemFooterButton = (param)=>{
    let { option, index, keyField, labelField, onRefresh, onApply } = param;
    var _option_icon;
    const isInBottomSheet = useIsInBottomSheet();
    const { popBottomSheetPage } = useOverlayContext();
    const button = /*#__PURE__*/ _jsx(TextButton, {
        // eslint-disable-next-line custom/no-hardcoded-bi-name-in-seagull -- EnhancedAutocomplete owns the inherent add-new-item action; consumers can't rename it (rule 6a)
        bi: {
            name: 'add_new_item'
        },
        className: styles.addNewItemOption,
        testId: EnhancedAutocompleteTestIds.NewItemOption(index),
        underline: "none",
        prefixIcon: (_option_icon = option.icon) !== null && _option_icon !== void 0 ? _option_icon : /*#__PURE__*/ _jsx(PlusCircle, {}),
        disabled: option.disabled,
        tooltip: option.disabled && option.disabledTooltip ? {
            title: option.disabledTooltip,
            placement: 'top'
        } : undefined,
        onMouseDown: async ()=>{
            if (option.disabled) return;
            const newItem = await option.onClick();
            await (onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh());
            if (newItem) {
                onApply(mapDataToOption(newItem, keyField, labelField));
            }
            if (isInBottomSheet) {
                popBottomSheetPage();
            }
        },
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "paragraph1",
            weight: "normal",
            skin: option.disabled ? 'disabled' : 'primary',
            children: option.text
        })
    });
    return option.disabled ? /*#__PURE__*/ _jsx("div", {
        className: styles.addNewItemOptionWrapper,
        onMouseDown: (e)=>e.preventDefault(),
        children: button
    }) : button;
};
